/**
 * Per-pair volatility served by `GET v1/hub/paper-trading/pair-volatility`,
 * recomputed every 5 minutes for every arena matchmaking tier pair. A pair whose
 * 30-minute window has too few recorded candles is absent.
 */
export type PaperPairVolatilityDto = {
  /** Clean CCXT pair symbol, e.g. `"BTC/USDC:USDC"`. */
  pairSymbol: string;
  /** Sample std dev of 15s log returns over the last 30 minutes. */
  stdDevLogReturns: number;
  /** Effective paper max leverage used in `score`. */
  maxLeverage: number;
  /** Achievable PnL swing: `stdDevLogReturns × maxLeverage`. Higher = hotter. */
  score: number;
};

export type PaperPairVolatilityResponse = {
  /** ISO timestamp of the run that produced `pairs`. */
  computedAt: string;
  pairs: PaperPairVolatilityDto[];
};

/** Snapshot age past which clients must stop flagging hot pairs (3 missed 5-minute runs). */
export const PAPER_PAIR_VOLATILITY_STALE_AFTER_MS = 15 * 60 * 1000;
